import React from 'react';

export const BrandSymbol: React.FunctionComponent = () => {
  return (
    <svg width="37" height="48" viewBox="0 0 37 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.8542 0.682027C19.7239 -0.789861 22.4676 0.244583 22.9349 2.5976L29.7823 37.0756C30.0818 38.5836 29.292 40.0967 27.8939 40.6936L11.3786 47.7451C9.57423 48.5155 7.5177 47.4702 7.04668 45.5432L0.0937822 17.0979C-0.209646 15.8566 0.237065 14.5505 1.23332 13.7662L17.8542 0.682027Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.3723 46.5133L34.3422 44.4599C35.4119 44.3224 36.1799 43.3614 36.0782 42.2877L32.6911 6.5193C32.5679 5.21748 31.249 4.38221 30.0194 4.82723L25.3404 6.52065L31.3453 36.7565C31.7945 39.0185 30.6099 41.2882 28.5128 42.1836L18.3723 46.5133ZM12.494 47.2691L27.8942 40.6937C29.2922 40.0968 30.082 38.5837 29.7825 37.0757L23.8233 7.06972L17.9892 9.18122C16.2133 9.82395 16.2972 12.3637 18.1116 12.8878C18.6278 13.0369 19.0595 13.3924 19.3049 13.8703L20.2033 15.6196C20.7912 16.7644 20.1605 18.1585 18.9124 18.4727L7.78108 21.2749C6.76197 21.5314 6.11524 22.5329 6.30071 23.5673L7.56553 30.6215L9.68113 45.6386C9.8339 46.7231 10.8304 47.483 11.9166 47.3433L12.494 47.2691Z"
        fill="white"
      />
      <path
        d="M21.9213 38.8855C21.9213 38.8855 14.5734 36.9935 16.5937 33.3636C17.7068 31.1349 20.2805 32.7618 20.2805 32.7618C20.2805 32.7618 21.9983 29.5989 24.2697 31.6929C26.9399 33.68 21.9213 38.8855 21.9213 38.8855Z"
        fill="#D10A36"
      />
    </svg>
  );
};
